export default __webpack_public_path__ + "static/media/aksamitka.f6ff6a6d.svg";